export default {
  LIST: {
    TITLE: `Liste des annonces`,
    SUMMARY: `Publiez des messages sur ce babillard aux employés de votre choix, voyez qui a consulté le message et envoyez-le directement par courriel ou SMS pour plus d’impact.`
  },
  CREATE_HEADER: {
    TITLE: `Créer une annonce`,
    SUMMARY: `Les annonces peuvent être marquées comme visibles par seulement un ou des segments des utilisateurs via leurs équipes, départements ou données d'embauches. Les annonces seront visibles par défaut à partir de l'application web et de l'application mobile, il sera par la suite possible de les envoyer par courriel ou SMS.`
  },
  EDIT: {
    TITLE: `Modifier l'annonce`,
    SUMMARY: `Les annonces peuvent être marquées comme visibles par seulement un ou des segments des utilisateurs via leurs équipes, départements ou données d'embauches. Les annonces seront visibles par défaut à partir de l'application web et de l'application mobile, il sera par la suite possible de les envoyer par courriel ou SMS.`
  },
  VIEW: {
    TITLE: `Détail de l'annonce`,
    SUMMARY: ``
  },
  VIEW_ARCHIVED: `Afficher les annonces archivées`,
  HIDE_ARCHIVED: `Cacher les annonces archivées`,
  ARCHIVED: `Archivée`,
  CREATE: `Créer une annonce`,
  SEND_NOTIFICATIONS: `Envoyer une notification`,
  NOTIFICATIONS_STATUS: `Statut de la notification`,
  PUBLISHED_BY: 'Publiée par {{ name }} le {{ date }}',
  MODIFIED_BY: `Dernière modification par {{ name }} le {{ date }}`,
  SHOWN_ON: `Affichée du {{ start }} au {{ end }}`,
  UNSENT_SMS_NOTIFICATIONS: `Un bulletin a une notification SMS non envoyée!`,
  UNSENT_SMS_NOTIFICATIONS_other: `{{ count }} bulletins ont une notification SMS non envoyée!`,
  VISIBLE_FOR: `Affichée pour`,
  VISIBLE_TO_EVERONE: `Affichée à tous les utilisateurs.`,
  SHOWN_UNTIL: `Affichée jusqu'au {{ end }}`,
  SHOWN_FROM: `Affichée à partir du {{ start }}`,
  READ_BY: {
    TITLE: `Lue par`,
    SUMMARY: ``
  },
  DELETE: `Supprimer`,
  PIN: `Épingler l'annonce`,
  UNPIN: `Détacher l'annonce du haut`,
  ARCHIVE: `Archiver`,
  UNARCHIVE: `Désarchiver`,
  DELETE_MODAL: {
    TITLE: `Supprimer l'annonce`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette annonce?`,
    PRIMARY_ACTION: `Supprimer`
  },
  NOTIFICATION_STATUS: {
    TITLE: `Statut de la notification`,
    SUMMARY: ``
  },
  SMS: `Messages textes`,
  EMAILS: `Courriels`,
  ERRORS: `Erreurs`,
  PENDING: `En attente`,
  DELIVERED: `Livrés`,
  OPENED: `Ouverts`,
  SEND_NOTIFICATIONS_MODAL: {
    TITLE: `Envoyer une notification d'annonce`,
    SUMMARY: `En cliquant sur Envoyer, {{amount}} utilisateurs recevront cette annonce`
  },
  SEND_BY_EMAIL: `Envoyer par courriel (gratuitement)`,
  NO_EMAIL_VERSION: `Il n'est pas possible d'envoyer le message par courriel lorsqu'il n'a pas de contenu, veuillez ajouter du contenu.`,
  SEND_BY_SMS: `Envoyer par message texte`,
  NO_SMS_VERSION: `Il n'est pas possible d'envoyer le message par message texte lorsqu'il n'y a pas de version message texte, veuillez en ajouter une.`,
  SMS_CREDIT_COST: `Envoyer cette annonce pourrait coûter jusqu'à {{credit}} crédits.`,
  BULLETIN_SENT: `Annonce envoyée`,
  BULLETIN_SENT_DESC: `La notification peut prendre de quelques minutes à plusieurs heures avant d'être reçue par tous les utilisateurs, cela dépend de la longueur du message et du nombre d'utilisateurs.`,
  form: {
    TITLE: {
      LABEL: `Titre`,
      PLACEHOLDER: `Entrez le titre de l'annonce`,
      DESCRIPTION: `Le titre va être utilisé dans la notification afin de donner du contexte à l'utilisateur avant d'ouvrir l'annonce.`
    },
    CONTENT: {
      LABEL: `Contenu`,
      DESCRIPTION: ``
    },
    SMSCONTENT: {
      LABEL: `Version message texte de l'annonce`,
      PLACEHOLDER: `Entrez une version condensée qui sera envoyée aux utilisateurs par message texte.`,
      DESCRIPTION: `Ce texte sera utilisé afin de donner du contexte à l'utilisateur dans le message texte.`
    },
    ISIMPORTANT: {
      LABEL: `Marquer cette annonce comme importante`,
      DESCRIPTION: `Un point d'exclamation rouge sera ajouté à côté du titre.`
    },
    PINNED: {
      LABEL: `Fixer l'annonce`,
      DESCRIPTION: `L'annonce restera affichée au-dessus des autres.`
    },
    HASSTART: {
      LABEL: `Cette annonce a une date de début`,
      DESCRIPTION: `L'annonce ne sera pas visible avant cette date.`
    },
    HASEND: {
      LABEL: `Cette annonce a une date de fin`,
      DESCRIPTION: `L'annonce ne sera plus visible après cette date.`
    },

    HASFILTER: {
      LABEL: `Limiter la visibilité de cette annonce`,
      DESCRIPTION: ``
    },
    START: {
      LABEL: `Date de début de publication`,
      PLACEHOLDER: `Entrer la date de début`,
      DESCRIPTION: ``
    },
    RANGE: {
      LABEL: `Durée de publication`,
      PLACEHOLDER: `Entrer la durée`,
      DESCRIPTION: ``
    },
    BULLETINFILTER: {
      LABEL: `Visible pour:`,
      DESCRIPTION: ``
    },

    SMS_CONTENT_COST: `Cette annonce utilisera {{credit}} crédit(s) par utilisateur.`,
    SMS_CONTENT_EXPENSIVE_CARACTERS: `Ces caractères peuvent augmenter de manière considérable le coût du message, pensez à les remplacer: <0>{{expensiveCaracters}}</0>.`,
    BULLETIN_OPTIONS: `Autres options`,
    EXAMPLE_SMS: `Bonjour {{ name }}, {{ companyNameFr }} t'a envoyé un message. \n\n{{ smsContent }}`,
    EXAMPLE_SMS_CONTENT: `Bonjour {{ name }}, {{ companyNameFr }} t'a envoyé un message. \n\n{{ smsContent }} \n\nConnecte-toi à Merinio pour plus de détails: URL`,
    SMS_CONTENT_PREVIEW: `Prévisualisation du sms`
  },
  NO_BULLETINS: `Aucune annonce à afficher.`,
  END_BEFORE_START: `La date de fin doit être après la date de début.`
}
